import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { stringToNumber } from '@/utils/numbers';
import { ButtonV2 as Button } from '@/components/Button';
import { Drawer, DrawerContent } from '@/components/FormElements/internal/Drawer';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.1548 0.488155C17.8057 -0.162718 18.861 -0.162718 19.5118 0.488155C20.1627 1.13903 20.1627 2.1943 19.5118 2.84518L12.357 10L19.5118 17.1548C20.1627 17.8057 20.1627 18.861 19.5118 19.5118C18.861 20.1627 17.8057 20.1627 17.1548 19.5118L10 12.357L2.84518 19.5118C2.1943 20.1627 1.13903 20.1627 0.488156 19.5118C-0.162719 18.861 -0.162719 17.8057 0.488156 17.1548L7.64298 10L0.488156 2.84518C-0.162718 2.1943 -0.162718 1.13903 0.488156 0.488155C1.13903 -0.162718 2.19431 -0.162718 2.84518 0.488155L10 7.64298L17.1548 0.488155Z",
      fill: "#BABDCC"
    })
  }));
};

CloseIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.00039 2.3066L9.30671 7.00281e-08L10 1.48679L5.57813 3.85403C5.39873 3.95003 5.20093 4 5.00039 4C4.79984 4 4.60205 3.95003 4.42264 3.85403L0 1.48679L0.694067 4.46499e-07L5.00039 2.3066Z",
      fill: "#12131A"
    })
  }));
};

ArrowDownIcon.defaultProps = {
  width: "10",
  height: "4",
  viewBox: "0 0 10 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const PANEL_WIDTH_LOCAL_STORAGE_KEY = 'galleryPanelWidth';

const GalleryPanel = _ref => {
  let {
    nameSpace,
    title,
    description,
    primaryAction = null,
    secondaryAction = null,
    headingActions = null,
    collapsibleFooter = false,
    isResizeable = false,
    isCloseButtonHidden,
    isFooterCollapsed,
    panelWidth,
    isMobile,
    className,
    children,
    footer,
    classNames = {},
    onClose,
    onFooterCollapseStateChange
  } = _ref;
  const handlePanelResizeEnd = useCallback(newWidth => {
    // Save the panel width to local storage
    if (!nameSpace) return;
    localStorage.setItem(PANEL_WIDTH_LOCAL_STORAGE_KEY, `${newWidth}`);
  }, [nameSpace]);
  const {
    size,
    panelRef,
    resizingRef,
    handleStartResize: handleResizeStart
  } = useResizePanel({
    enableResize: isResizeable,
    initialWidth: stringToNumber(localStorage.getItem(PANEL_WIDTH_LOCAL_STORAGE_KEY) ?? '', panelWidth),
    minWidth: panelWidth,
    onResizeEnd: handlePanelResizeEnd
  });
  const displayFooter = primaryAction || secondaryAction || footer || typeof onClose === 'function' && !isCloseButtonHidden;

  const content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("header", {
      className: styles.panelHeader,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.panelHeading,
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles.panelTitle,
          children: title
        }), headingActions]
      }), /*#__PURE__*/_jsx("p", {
        className: styles.panelDescription,
        children: description
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: clsx(styles.panelContent, classNames.panelContent),
      children: children
    }), displayFooter && !footer ? /*#__PURE__*/_jsxs(PanelFooter, {
      className: classNames.panelFooter,
      collapsible: collapsibleFooter,
      isCollapsed: isFooterCollapsed,
      onCollapseStateChange: onFooterCollapseStateChange,
      children: [secondaryAction, !secondaryAction && typeof onClose === 'function' ? /*#__PURE__*/_jsx(Button, {
        variant: "link",
        size: "small",
        onClick: onClose,
        children: "Close"
      }) : null, primaryAction]
    }) : null, displayFooter && footer ? /*#__PURE__*/_jsx(PanelFooter, {
      className: classNames.panelFooter,
      collapsible: collapsibleFooter,
      isCollapsed: isFooterCollapsed,
      onCollapseStateChange: onFooterCollapseStateChange,
      children: footer
    }) : null]
  }); // render content as a Drawer on mobile


  if (isMobile) {
    return /*#__PURE__*/_jsx(Drawer, {
      open: true,
      onOpenChange: onClose,
      children: /*#__PURE__*/_jsx(DrawerContent, {
        children: content
      })
    });
  }

  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    ref: panelRef,
    className: clsx(styles.panel, {
      [styles['panel--resizing']]: resizingRef.current.active,
      [styles['panel--resizable']]: isResizeable
    }, className)
  }, isResizeable && {
    style: {
      width: size.width
    }
  }), {}, {
    children: [/*#__PURE__*/_jsx("button", {
      className: styles.panelClose,
      onClick: onClose,
      children: /*#__PURE__*/_jsx(CloseIcon, {})
    }), content, isResizeable ? /*#__PURE__*/_jsx("div", {
      className: clsx(styles.resizeHandle, {
        [styles['resizeHandle--expanded']]: panelWidth && size.width > panelWidth,
        [styles['resizeHandle--reachedEnd']]: resizingRef.current.reachedEnd
      }),
      onMouseDown: handleResizeStart
    }) : null]
  }));
};

const PanelFooter = props => {
  const {
    0: isCollapsed,
    1: setIsCollapsed
  } = useState(false);
  const isControlled = props.isCollapsed !== undefined;
  const controlledIsCollapsed = isControlled ? props.isCollapsed : isCollapsed;

  const toggleCollapse = () => {
    if (props.onCollapseStateChange) {
      props.onCollapseStateChange(!controlledIsCollapsed);
    } else {
      setIsCollapsed(!controlledIsCollapsed);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.panelFooterContainer, {
      [styles['panelFooterContainer--collapsed']]: controlledIsCollapsed
    }),
    style: {
      transform: !controlledIsCollapsed ? 'translateY(0%)' : 'translateY(100%)'
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx(styles.panelFooter, props.className),
      children: props.children
    }), props.collapsible ? /*#__PURE__*/_jsx("button", {
      className: clsx(styles.toggleFooter, {
        [styles['toggleFooter--open']]: controlledIsCollapsed
      }),
      onClick: () => toggleCollapse(),
      children: /*#__PURE__*/_jsx(ArrowDownIcon, {})
    }) : null]
  });
}; // Handle resizing of the panel


const useResizePanel = _ref2 => {
  let {
    enableResize = false,
    initialWidth = 400,
    minWidth = 200,
    onResizeEnd
  } = _ref2;
  const {
    0: size,
    1: setSize
  } = useState({
    width: initialWidth
  });
  const panelRef = useRef(null);
  const resizingRef = useRef({
    active: false,
    reachedEnd: false
  });
  const startPositionRef = useRef({
    x: 0,
    y: 0,
    width: 0
  }); // Store window width for recalculations

  const {
    0: windowWidth,
    1: setWindowWidth
  } = useState(window.innerWidth);
  const getPanelMaxWidth = useCallback(() => {
    var _panelRef$current;

    const panelRect = (_panelRef$current = panelRef.current) === null || _panelRef$current === void 0 ? void 0 : _panelRef$current.getBoundingClientRect(); // Calculate the absolute position of the panel's left edge

    const panelLeftPosition = (panelRect === null || panelRect === void 0 ? void 0 : panelRect.left) ?? 72; // default panel offset
    // Calculate maximum width based on window width and panel position
    // This ensures the panel doesn't exceed the right edge of the window

    return windowWidth - panelLeftPosition;
  }, [windowWidth]); // Make sure the panel width is never greater than the window width

  const boundedSize = useMemo(() => {
    return {
      width: Math.min(size.width, Math.max(minWidth, getPanelMaxWidth()))
    };
  }, [size.width, minWidth, getPanelMaxWidth]); // Process resizing when mouse moves

  const handleResizeMove = useCallback(e => {
    if (!resizingRef.current.active || !enableResize) return;
    const maxWidth = getPanelMaxWidth();
    const deltaX = e.clientX - startPositionRef.current.x;
    const newWidth = Math.min(Math.max(startPositionRef.current.width + deltaX, minWidth), maxWidth);
    resizingRef.current.reachedEnd = newWidth >= maxWidth;
    setSize({
      width: newWidth
    });
  }, [minWidth, enableResize, getPanelMaxWidth]); // End resizing when mouse up

  const handleResizeEnd = useCallback(() => {
    resizingRef.current.active = false; // Force re-render to update the resizing state

    setSize(size => {
      // Call onResizeEnd callback if provided
      // this is useful for saving the new size to local storage
      if (onResizeEnd) onResizeEnd(size.width);
      return {
        width: size.width
      };
    });
  }, [onResizeEnd]); // Start resizing when mouse down on the resize handle

  const handleStartResize = useCallback(e => {
    if (!enableResize) return;
    e.preventDefault();
    resizingRef.current.active = true;
    startPositionRef.current = {
      x: e.clientX,
      y: e.clientY,
      width: Math.min(size.width, getPanelMaxWidth())
    };
  }, [size, enableResize, getPanelMaxWidth]); // Clean up event listeners on unmount

  useEffect(() => {
    if (!enableResize) return; // Mouse events

    document.addEventListener('mousemove', handleResizeMove);
    document.addEventListener('mouseup', handleResizeEnd); // Resize event

    const handleWindowResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleWindowResize);
    return () => {
      // Clean up mouse events
      document.removeEventListener('mousemove', handleResizeMove);
      document.removeEventListener('mouseup', handleResizeEnd); // Clean up resize event

      window.removeEventListener('resize', handleWindowResize);
    };
  }, [enableResize, handleResizeMove, handleResizeEnd]);
  return {
    size: boundedSize,
    resizingRef,
    panelRef,
    handleStartResize,
    // Helper to reset panel to initial size
    resetSize: () => setSize({
      width: initialWidth
    })
  };
};

export default GalleryPanel;